var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list-group",
    {
      model: {
        value: _vm.active,
        callback: function($$v) {
          _vm.active = $$v
        },
        expression: "active"
      }
    },
    [
      _c(
        "v-list-tile",
        { attrs: { slot: "activator" }, slot: "activator" },
        [
          _c("v-list-tile-title", [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c(
            "v-list-tile-action",
            [
              _c(
                "v-btn",
                {
                  attrs: { flat: "", small: "", color: "primary" },
                  on: { click: _vm.handleAdd }
                },
                [_c("v-icon", [_vm._v("add")]), _vm._v(" add\n      ")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.items, function(item, i) {
        return _c(
          "v-list-tile",
          {
            key: i,
            on: {
              click: function($event) {
                return _vm.$emit("display", item)
              }
            }
          },
          [
            _c("v-list-tile-action"),
            _vm._v(" "),
            _c("v-list-tile-title", [
              _vm._v("\n      " + _vm._s(item.label) + "\n      "),
              _c("span", { staticClass: "node-id" }, [
                _vm._v("#" + _vm._s(item.id))
              ])
            ])
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c50b23fe", { render: render, staticRenderFns: staticRenderFns })
  }
}